import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from 'src/app/shared/Notification.service';

import { DistrictData } from 'src/app/shared/DistrictData.model';
import { DistrictDataService } from 'src/app/shared/DistrictData.service';
import { WardData } from 'src/app/shared/WardData.model';
import { WardDataService } from 'src/app/shared/WardData.service';
import { Species } from 'src/app/shared/Species.model';
import { SpeciesService } from 'src/app/shared/Species.service';

import { CompanyLake } from 'src/app/shared/CompanyLake.model';
import { CompanyLakeService } from 'src/app/shared/CompanyLake.service';

import { CompanyInfo } from 'src/app/shared/CompanyInfo.model';
import { CompanyInfoService } from 'src/app/shared/CompanyInfo.service';


@Component({
  selector: 'app-co-so-company-lake-detail',
  templateUrl: './co-so-company-lake-detail.component.html',
  styleUrls: ['./co-so-company-lake-detail.component.css']
})
export class CoSoCompanyLakeDetailComponent implements OnInit {

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<CoSoCompanyLakeDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,

    public NotificationService: NotificationService,

    public DistrictDataService: DistrictDataService,
    public WardDataService: WardDataService,
    public SpeciesService: SpeciesService,
    
    public CompanyLakeService: CompanyLakeService,
    public CompanyInfoService: CompanyInfoService,
    
  ) { }
  IsCompany = false
  ngOnInit(): void {
    this.SpeciesSearch();    
    this.DistrictDataSearch();
    this.CompanyInfoSearch();
    this.IsCompany = this.data.IsCompany;
  }  
  SetData(){
    if(this.data.DistrictDataID > 0){
      this.WardDataSearch(this.data.DistrictDataID,true);
    }
  }
  CompanyInfoSearch() {    
    this.CompanyInfoService.ComponentGet000ToListAsync();
  }
  CompanyInfoFilter(searchString: string) {
    this.CompanyInfoService.Filter000(searchString);
  }
  DistrictDataSearch() {
    this.CompanyLakeService.IsShowLoading = true;
    this.DistrictDataService.BaseParameter.ParentID = environment.ProvinceDataIDBenTre;
    this.DistrictDataService.GetByParentIDToListAsync().subscribe(
      res => {
        this.DistrictDataService.List = (res as DistrictData[]).sort((a, b) => (a.SortOrder > b.SortOrder ? 1 : -1));      
        this.CompanyLakeService.FormData = this.data;
        if(this.data.DistrictDataID > 0){
          this.SetData();
          this.CompanyLakeService.FormData.ParentID = this.CompanyInfoService.FormData.ID;
          this.CompanyLakeService.FormData.TypeName = this.CompanyInfoService.FormData.Name;
        }
        // this.WardDataSearch();
        this.CompanyLakeService.IsShowLoading = false;
      },
      err => {
        this.CompanyLakeService.IsShowLoading = false;
      }
    );
  }

  WardDataSearch(districtDataID:number,IsSetWardDataID:boolean) {
    this.WardDataService.BaseParameter.ParentID = districtDataID;
    this.CompanyLakeService.IsShowLoading = true;    
    this.WardDataService.BaseParameter.ParentID = this.CompanyLakeService.FormData.DistrictDataID;
    this.WardDataService.GetByParentIDToListAsync().subscribe(
      res => {
        this.WardDataService.List = (res as WardData[]).sort((a, b) => (a.SortOrder > b.SortOrder ? 1 : -1));
        this.CompanyLakeService.IsShowLoading = false;
      },
      err => {
        this.CompanyLakeService.IsShowLoading = false;
      }
    );
  }
  // WardDataSearch(districtDataID: number): Promise<void> {
  //   return new Promise((resolve, reject) => {
  //     this.WardDataService.BaseParameter.ParentID = districtDataID;
  //     this.WardDataService.GetByParentIDToListAsync().subscribe(
  //       res => {
  //         this.WardDataService.List = (res as WardData[]).sort((a, b) => a.SortOrder - b.SortOrder);
  //         resolve();
  //       },
  //       err => {
  //         reject(err);
  //       }
  //     );
  //   });
  // }
  SpeciesSearch() {
    this.SpeciesService.ComponentGetAllToListAsync();
  }

  CompanyLakeSave() {
    // Chặn save trên mobile
    if (this.NotificationService.blockMobileActionIfNeeded()) {
      return;
    }
    
    this.NotificationService.warn(this.CompanyLakeService.ComponentSaveForm());
  }
  
  Close() {
    this.dialogRef.close();
  }
}